import mapboxgl from 'mapbox-gl';

$(window).on('load', function () {
  mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNrbm9tOGpuczFmdnEyeHBuZnkydnN1azUifQ.m3CAOl1lcJ1ykK7FWmUIlw';

  const mapboxes = document.querySelectorAll('.dealer-map');
  if (mapboxes.length > 0) {
      mapboxes.forEach(mapbox => {
          initMap(mapbox, mapbox.querySelectorAll('.dealer-map__marker'));
      });
  }
});

const initMap = (mapboxMapElement, mapboxMarkers) => {
  if (!mapboxMapElement || !mapboxMarkers) {
    return;
  }

  const markerPosition = new mapboxgl.LngLat(mapboxMarkers[0].dataset.lng, mapboxMarkers[0].dataset.lat);
  const markers = [];
  const lat = [];
  const lng = [];

  const map = new mapboxgl.Map({
      container: mapboxMapElement,
      style: 'mapbox://styles/blackdesk/cklm41yt631sg17w3mnfqwo60',
      center: markerPosition,
      zoom: 14,
      minZoom: 0,
  });

  mapboxMarkers.forEach(marker => {
    const latitude = $(marker).attr('data-lat');
    const longitude = $(marker).attr('data-lng');
    const markerPos = new mapboxgl.LngLat(longitude, latitude);

    lat.push( latitude );
    lng.push( longitude );

    const el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = 'url(/wp-content/themes/lubo/resources/images/marker.svg)';
    el.style.width = '15px';
    el.style.height = '22px';
    el.style.marginTop = '-25px';
    el.style.backgroundSize = 'contain';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundPosition = 'center center';

    new mapboxgl.Marker(el)
      .setLngLat(markerPos)
      .addTo(map);

    markers.push(el);

    //Add popup
    // const contentPopup = $(marker).html();

    // Display popup on click
    // $(el).on('click', function(e) {
    //   e.stopPropagation();
    //   $('.mapboxgl-popup').remove();
    //   new mapboxgl.Popup({closeOnClick: true, offset: [0, -50]})
    //     .setLngLat(markerPos)
    //     .setHTML(contentPopup)
    //     .addTo(map);
    // });
  })

  map.on('load', function() {
    var x = 0.008;
    //Get highest and lowest coordinate
    var sw = new mapboxgl.LngLat(Math.min(...lng) - x, Math.min(...lat) - x);
    var ne = new mapboxgl.LngLat(Math.max(...lng) + x, Math.max(...lat) + x);

    var llb = new mapboxgl.LngLatBounds(ne, sw);
    map.fitBounds(llb);
  });
}
